import { Component } from '@angular/core';

@Component({
	selector: 'app-leap-manage-modal',
	templateUrl: './leap-manage-modal.component.html',
	standalone: false,
})
export class LeapManageModalComponent {}
